import React from 'react';
import { Col, Modal, Row, Translate } from '../../../Share/components';
import { isIE } from '../../../Share/utils';
import PropTypes from 'prop-types';

DuplicateOrder.propTypes = {
  errorMessage: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isVisible: PropTypes.bool,
};

function DuplicateOrder({
  isVisible = false,
  errorMessage = '',
  onClose = () => {},
  onSubmit = () => {},
}) {
  return (
    <Modal
      isVisible={isVisible}
      className="tv-booknow__modal tv-booknow__modal-duplicate-order"
      onCloseClicked={onClose}
      headerClassName={`tv-booknow__modal-cancel-header ${
        isIE ? 'ie-fix-width' : ''
      }`}
      headerText={Translate({ content: 'bookNow.bookAnInterpreterToday' })}
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <div className="px-2 py-4">
        <div>{errorMessage}</div>
        <Row>
          <Col className="pr-2">
            <button
              onClick={onClose}
              className="tv-booknow__modal-actions-button_cancel"
            >
              <Translate content="bookNow.cancel" />
            </button>
          </Col>
          <Col className="pl-2">
            <button
              onClick={onSubmit}
              className="tv-booknow__modal-actions-button_submit"
            >
              <Translate content="bookNow.continueOrder" />
            </button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
}

export default DuplicateOrder;
